// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__361iI","actions":"GroupTable_actions__2OSeu","deleteModalFooter":"GroupTable_deleteModalFooter__3vXWf"};